<script setup lang="ts">
import { Category } from '@/objects/generated';
import { computed } from 'vue';

const props = defineProps<{
    cats: Array<Category>;
    maxLabels?: number;
    breakEveryN?: number;
}>();

const catstoShow = computed(() => {
    // We get the unique categories by id
    const uniqueCats: Map<number, Category> = new Map();
    for (const cat of props.cats) {
        if (!uniqueCats.has(cat.ID)) {
            uniqueCats.set(cat.ID, cat);
        }
    }

    const uniqueCatsArray = Array.from(uniqueCats.values());

    if (props.maxLabels && uniqueCatsArray.length > props.maxLabels) {
        return uniqueCatsArray.slice(0, props.maxLabels);
    }
    return uniqueCatsArray;
});
</script>
<template>
    <div>
        <template
            v-for="(cat, i) in catstoShow"
            :key="cat.ID"
        >
            <br v-if="i > 0 && i % (breakEveryN || 200) == 0" />
            <span
                v-if="!maxLabels || i < maxLabels"
                class="badge me-1"
                :class="{
                    'bg-red-600': cat.Gender == 'f',
                    'bg-blue-600': cat.Gender == 'm',
                    'bg-orange-700': cat.Gender == null || cat.Gender == 'n',
                }"
                >{{ cat.Name }}</span
            >
            <span v-if="maxLabels && maxLabels == i + 1"> ... </span>
        </template>
    </div>
</template>
